/**
 * @generated SignedSource<<1131fe278260cfc9d5278a55ba4cb0ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type LessonAccess = "BOOKING" | "NONE" | "REQUEST";
import { FragmentRefs } from "relay-runtime";
export type LessonCourseControlNode$data = {
  readonly allLessonStartSlotIds?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly course: {
          readonly id: string;
        };
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly firstStartSlot?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly agenda: {
          readonly facility: {
            readonly club: {
              readonly supportsPrivate: boolean;
            } | null | undefined;
            readonly copyOverrides: {
              readonly course: {
                readonly singular: string;
              } | null | undefined;
            };
            readonly courses: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly courseBucket: {
                    readonly id: string;
                  } | null | undefined;
                  readonly description: string | null | undefined;
                  readonly facility: {
                    readonly type: FacilityType;
                  };
                  readonly id: string;
                  readonly name: string;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly privateLessonsPermissionSet: {
              readonly patronAccess: LessonAccess | null | undefined;
              readonly patronSelectVenue: boolean | null | undefined;
            } | null | undefined;
            readonly publicLessonsPermissionSet: {
              readonly patronAccess: LessonAccess | null | undefined;
              readonly patronSelectVenue: boolean | null | undefined;
            } | null | undefined;
            readonly type: FacilityType;
          };
        };
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "LessonCourseControlNode";
};
export type LessonCourseControlNode$key = {
  readonly " $data"?: LessonCourseControlNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonCourseControlNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "fields": [
    {
      "kind": "Literal",
      "name": "bookingType",
      "value": "LESSON"
    },
    {
      "kind": "Variable",
      "name": "facilityId",
      "variableName": "facilityId"
    },
    {
      "kind": "Variable",
      "name": "lessonTypeId",
      "variableName": "lessonTypeId"
    }
  ],
  "kind": "ObjectValue",
  "name": "slotAvailability"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronSelectVenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronAccess",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "facilityId"
    },
    {
      "kind": "RootArgument",
      "name": "lessonTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonCourseControlNode",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "allLessonStartSlotIds",
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "TimeSlotConnection",
          "kind": "LinkedField",
          "name": "startSlots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSlotEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlot",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Course",
                      "kind": "LinkedField",
                      "name": "course",
                      "plural": false,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "firstStartSlot",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            (v0/*: any*/)
          ],
          "concreteType": "TimeSlotConnection",
          "kind": "LinkedField",
          "name": "startSlots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSlotEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlot",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Agenda",
                      "kind": "LinkedField",
                      "name": "agenda",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Facility",
                          "kind": "LinkedField",
                          "name": "facility",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Club",
                              "kind": "LinkedField",
                              "name": "club",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "supportsPrivate",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PrivateLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "privateLessonsPermissionSet",
                              "plural": false,
                              "selections": (v4/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PublicLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "publicLessonsPermissionSet",
                              "plural": false,
                              "selections": (v4/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FacilityCopyOverrides",
                              "kind": "LinkedField",
                              "name": "copyOverrides",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "NounOverride",
                                  "kind": "LinkedField",
                                  "name": "course",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "singular",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CourseConnection",
                              "kind": "LinkedField",
                              "name": "courses",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "CourseEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Course",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "CourseBucket",
                                          "kind": "LinkedField",
                                          "name": "courseBucket",
                                          "plural": false,
                                          "selections": (v2/*: any*/),
                                          "storageKey": null
                                        },
                                        (v1/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "name",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "description",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "Facility",
                                          "kind": "LinkedField",
                                          "name": "facility",
                                          "plural": false,
                                          "selections": [
                                            (v3/*: any*/)
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "AvailabilitySlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "ef6b23bff70a210f86a766d05a4c4cab";

export default node;
